"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import CrossStorage from "./CrossStorage";
const token_1 = require("./http/token");
// 初始化一些sdk的基础信息
const launch = (config = {}) => {
    const { 
    // env = 'prod-ml',
    isApp = false, initialAccessToken = "", initialRefreshToken = "", 
    // onReady,
    onTokenExpire, readToken, writeToken, } = config;
    if (TARGET === "web") {
        // const instance = new CrossStorage(env, onReady)
        window.__sensecommon = {
            // env,
            isApp,
            // cs: instance,
            isReloading: false,
        };
    }
    else {
        (0, token_1.setToken)("accessToken", initialAccessToken);
        (0, token_1.setToken)("refreshToken", initialRefreshToken);
        process.__sensecommon = {
            // env,
            readToken,
            writeToken,
            onTokenExpire,
        };
    }
};
exports.default = launch;
